import { setSpecificMessage, minLength } from "valibot";
setSpecificMessage(
  minLength,
  (issue) => `Longeur invalide: attendu ${issue.expected}, mais reçu ${issue.received}`,
  "fr"
);